import { useSelector } from 'react-redux';
// eslint-disable-next-line import/no-cycle
import CONFIG from '../../api/config';

export default function useNavigateHome() {
    const isHeadCoach = useSelector((state: any) => !!state.user?.headCoach);
    const isAssistantCoach = useSelector((state: any) => !!state.user?.loggedInUser?.isAssistantCoachUser);
    const isCoach = isAssistantCoach || isHeadCoach;

    return {
        url: isCoach ? CONFIG.URL_COACHAPP: CONFIG.URL_MARKETPLACE,
        label: isCoach ? 'Back to Coach Heroic' : 'Back to Athlete Web'  
    }
}
